import { FilterOperators, IntegrationFilter } from './filter-types'

export function getOperatorByFilterType(filter: IntegrationFilter): FilterOperators {
  switch (filter.filterType) {
    case 'date':
      return '<'
    case 'dropdown':
      return filter.multiValue ? 'IN' : '='
    default:
      return '='
  }
}
